<template>
    <div id="map">
        <div id="info" class="esri-widget">
            <auth/>
        </div>
        <div id="addData" class="esri-widget">
            <AssetDataButton/>
        </div>

    </div>
</template>

<script>
import {loadModules} from 'esri-loader';
import debounce from 'lodash.debounce'
import AssetDataButton from "@/components/AssetDataButton";
import auth from '@/components/auth.vue'

export default {
        name: 'MainMap',
        components: {AssetDataButton, auth},
        data: function () {
          return {
            fac_filter_geom: undefined,
          }
        },
        props: [
            "filter_project_system",
            "filter_project_FAC",
            "filter_project_type",
            "filter_start_year",
            "filter_end_year",
            "filter_cost",
            "filter_street",
            "start_years",
            "end_years",
            'project_types'
        ],
        computed: {
          fac_filter: function () {
            let filter = {}
            if (this.filter_project_FAC && this.filter_project_FAC.length) {
              filter.where = `large_area_id in (${this.filter_project_FAC.map(f => `${f}`).join(',')})`
            }
            return filter
          },
            filter: function () {
                let filter = {}
                let parts = [];
                if (this.filter_project_system && this.filter_project_system.length) {
                    let system = `project_system in (${this.filter_project_system.map(f => `'${f}'`).join(',')})`;
                    parts.push(system);
                }
                if (this.filter_project_type && this.filter_project_type.length) {
                    let valid_project_types = this.filter_project_type.filter(f => f !== 'Missing');
                    let type = `project_type in (${valid_project_types.map(f => `'${f}'`).join(',')})`;

                    if (valid_project_types.length && valid_project_types.length < this.filter_project_type.length) {
                        parts.push('(' + type + ' OR project_type is null)');
                    } else if (valid_project_types.length === 0) {
                        parts.push('project_type is null');
                    } else {
                        parts.push(type);
                    }
                }
                if (this.filter_start_year && this.filter_start_year.length) {
                    let valid_start_years = this.filter_start_year.filter(f => f !== 'Missing');
                    let startyear = `start_year in (${valid_start_years.map(f => `${f}`).join(',')})`;

                    if (valid_start_years.length && valid_start_years.length < this.filter_start_year.length) {
                        parts.push('(' + startyear + ' OR start_year is null)');
                    } else if (valid_start_years.length === 0) {
                        parts.push('start_year is null');
                    } else {
                        parts.push(startyear);
                    }
                }
                if (this.filter_end_year && this.filter_end_year.length) {
                    let valid_end_years = this.filter_end_year.filter(f => f !== 'Missing');
                    let endyear = `end_year in (${valid_end_years.map(f => `${f}`).join(',')})`;

                    if (valid_end_years.length && valid_end_years.length < this.filter_end_year.length) {
                        parts.push('(' + endyear + ' OR end_year is null)');
                    } else if (valid_end_years.length === 0) {
                        parts.push('end_year is null');
                    } else {
                        parts.push(endyear);
                    }
                }

                if (this.filter_cost[0]) {
                    let min_cost = `project_cost >= ${this.filter_cost[0]}`;
                    parts.push(min_cost);
                }

                if (this.filter_cost[1]) {
                    let max_cost = `project_cost <= ${this.filter_cost[1]}`;
                    parts.push(max_cost);
                }

                if (this.filter_street) {
                    let street = `UPPER(street_list) LIKE '%${this.filter_street.toUpperCase()}%'`;
                    parts.push(street);
                }

                if (parts.length === 1) {
                    filter.where = parts[0]
                } else {
                    filter.where = parts.join(' and ')
                }

                if (this.fac_filter_geom) {
                  filter.geometry = this.fac_filter_geom
                  filter.spatialRelationship = 'intersects'
                }

                return filter
            },
        },
        methods: {
            query: function (data_field, vue_field, layer) {
                let vue_this = this;
                let query = vue_this[layer].createQuery();
                query.outFields = [data_field];
                query.returnDistinctValues = true;
                query.returnGeometry = false;
                vue_this[layer].queryFeatures(query)
                    .then(function (response) {
                        response.features.forEach(f => vue_this[vue_field].push(f.attributes[data_field]))
                    });
            },
            fac_query: debounce(function () {
              let vue_this = this;
              loadModules(["esri/geometry/geometryEngine"])
                  .then(([geometryEngine]) => {
                    let query = vue_this.largeareas.createQuery();
                    if (vue_this.fac_filter.where) {
                      query.where = vue_this.fac_filter.where
                      query.returnGeometry = true
                      vue_this.largeareas.queryFeatures(query)
                          .then(function (response) {
                            vue_this.fac_filter_geom = geometryEngine.union(Object.keys(response.features).map(f => response.features[f].geometry))
                          });
                    }
                  })
            }, 150, {leading: true, maxWait: 600}),
          getData: function(layer) {
                this.query('start_year', 'start_years', layer)
                this.query('end_year', 'end_years', layer)
                this.query('project_type', 'project_types', layer)
            },
            createFillSymbol: function (value, color) {
                return {
                    value: value,
                    symbol: {
                        color: color,
                        type: "simple-fill",
                        style: "solid",
                        outline: {
                            style: "solid",
                            type: "simple-line",
                            width: '4px',
                            color: color,
                        }
                    },
                    label: value
                };
            },
            createLineSymbol: function (value, color) {
                return {
                    value: value,
                    symbol: {
                        color: color,
                        type: "simple-line",
                        style: "solid",
                        width: "6px"
                    },
                    label: value
                };
            },
            createMarkerSymbol: function (value, color) {
                return {
                    value: value,
                    symbol: {
                        type: "simple-marker",
                        color: color,
                        size: "11px"
                    }
                }
            },
        },
        mounted() {
            // lazy load the required ArcGIS API for JavaScript modules and CSS
            let vue_this = this;
            loadModules(['esri/Map', 'esri/views/MapView', "esri/layers/WebTileLayer", "esri/Basemap", "esri/widgets/Legend", "esri/widgets/Search", "esri/layers/FeatureLayer", "esri/widgets/BasemapGallery", "esri/widgets/Expand", "esri/views/layers/support/FeatureFilter"], {css: true})
                .then(([ArcGISMap, MapView, WebTileLayer, Basemap, Legend, Search, FeatureLayer, BasemapGallery, Expand, FeatureFilter]) => {

                    let transportationBaseLayer = new WebTileLayer({
                        urlTemplate: "https://api.mapbox.com/styles/v1/semcog/cjd0blsjp1dvr2speyyrtz1uh/tiles/256/{level}/{col}/{row}@2x?access_token=pk.eyJ1Ijoic2VtY29nIiwiYSI6ImlvNEFUcmMifQ.VmDLZZG7l6syscFzkBs5eg",
                        subDomains: ["a", "b", "c", "d"],
                        copyright: 'SEMCOG'
                    });

                    let pavementCondBaseLayer = new WebTileLayer({
                        urlTemplate: "https://api.mapbox.com/styles/v1/semcog/ck8kmn2cj0my61il3hzg4hmp8/tiles/256/{level}/{col}/{row}@2x?access_token=pk.eyJ1Ijoic2VtY29nIiwiYSI6ImlvNEFUcmMifQ.VmDLZZG7l6syscFzkBs5eg",
                        subDomains: ["a", "b", "c", "d"],
                        copyright: 'SEMCOG'
                    });

                    let mcdLabelsBaseLayer = new WebTileLayer({
                        urlTemplate: "https://api.mapbox.com/styles/v1/semcog/cjcteiclg0zt62spp84drsqks/tiles/256/{level}/{col}/{row}@2x?access_token=pk.eyJ1Ijoic2VtY29nIiwiYSI6ImlvNEFUcmMifQ.VmDLZZG7l6syscFzkBs5eg",
                        subDomains: ["a", "b", "c", "d"],
                        copyright: 'SEMCOG'
                    });

                    let pavementCondbasemap = new Basemap({
                        baseLayers: [pavementCondBaseLayer],
                        title: "Pavement Condition",
                        id: "pavement",
                        thumbnailUrl: "https://api.mapbox.com/styles/v1/semcog/ck8kmn2cj0my61il3hzg4hmp8/tiles/256/13/2208/3029@2x?access_token=pk.eyJ1Ijoic2VtY29nIiwiYSI6ImlvNEFUcmMifQ.VmDLZZG7l6syscFzkBs5eg"
                    });

                    let basemap = new Basemap({
                        baseLayers: [transportationBaseLayer, mcdLabelsBaseLayer],
                        title: "Transportation with Communities",
                        id: "transportation-communities",
                    });

                    this.map = new ArcGISMap({
                        basemap: basemap
                        });

                    this.view = new MapView({
                        container: this.$el,
                        map: this.map,
                        center: [-83.2437186609522, 42.454430721108764],
                        zoom: 9
                    });

                    let basemapGallery = new BasemapGallery({
                        source: {
                            query: {
                                id: '010923f7658d4a46b4fa1aa54c6d4b26'
                            }
                        },
                        view: this.view
                    });
                    basemapGallery.source.basemaps.items.push(pavementCondbasemap)
                    basemapGallery.source.basemaps.items.push(basemap)

                    let bgExpand = new Expand({
                        view: this.view,
                        content: basemapGallery
                    });

                    this.view.ui.add(bgExpand, "top-left");

                    this.view.ui.add("info", "top-right");

                    var searchWidget = new Search({
                        view: this.view
                    });
                    let sExpand = new Expand({
                        view: this.view,
                        content: searchWidget
                    });
                    this.view.ui.add(sExpand, {
                        position: "top-left"
                    });

                    var popupCIP = {
                        "title": "{project_system} Capital Improvement Project",
                        "content": "Name: {project_name} <br>Type: {project_type} <br>Streets: {street_list} <br>Cost: ${project_cost} <br> Construction Start Year: {start_year} <br> Construction End Year: {end_year}<br> Agency: {contact_agency} <br> Project Description: {project_description}",
                        "fieldInfos": [{
                            fieldName: "start_year",
                            visible: true,
                            format: {
                                places: 0,
                                "digitSeparator": false
                            }
                        },
                        {
                            fieldName: "end_year",
                            visible: true,
                            format: {
                                places: 0,
                                "digitSeparator": false
                            }
                        }],
                    };

                    let polyRenderer = {
                        type: "unique-value",
                        field: "project_system",
                        legendOptions: {
                             title: "Project System"
                        },
                        uniqueValueInfos: [
                            this.createFillSymbol("Road", "#3c3d3b"),
                            this.createFillSymbol("Water", "#3969AC"),
                            this.createFillSymbol("Sewer", "#11A579"),
                            this.createFillSymbol("Storm", "#F2B701"),
                            this.createFillSymbol("Electric", "#E73F74"),
                            this.createFillSymbol("Gas", "#80BA5A"),
                            this.createFillSymbol("Telecommunications", "#4b4b8f"),
                        ]
                    };

                    this.cip_polygons = new FeatureLayer({
                        url: "https://services5.arcgis.com/7W8dXhZugABWPKmQ/arcgis/rest/services/PolygonLayer_region/FeatureServer/0",
                        outFields: ["project_name", "project_cost", "start_year", "end_year", "project_type", "contact_agency", "project_system"],
                        popupTemplate: popupCIP,
                        renderer: polyRenderer,
                    });

                    this.view.whenLayerView(this.cip_polygons).then(f => f.filter = new FeatureFilter(this.filter))

                    this.map.add(this.cip_polygons, 2);

                    this.cip_polygons.when(function () {
                    }, function (e) {
                        alert(e.message + "\n\rPlease login with an account associated with the SEMCOG Asset Management Program. \n \r For more information visit: https://asset-semcog.hub.arcgis.com/")
                    })

                    this.getData('cip_polygons');

                    let linesRenderer = {
                        type: "unique-value",
                        field: "project_system",
                        legendOptions: {
                            title: "Project System"
                        },
                        uniqueValueInfos: [
                            this.createLineSymbol("Road", "#3c3d3b"),
                            this.createLineSymbol("Water", "#3969AC"),
                            this.createLineSymbol("Sewer", "#11A579"),
                            this.createLineSymbol("Storm", "#F2B701"),
                            this.createLineSymbol("Electric", "#E73F74"),
                            this.createLineSymbol("Gas", "#80BA5A"),
                            this.createLineSymbol("Telecommunications", "#4b4b8f"),
                        ]
                    };

                    this.cip_lines = new FeatureLayer({
                        url: "https://services5.arcgis.com/7W8dXhZugABWPKmQ/arcgis/rest/services/PolyLineLayer_region/FeatureServer/0",
                        outFields: ["project_name", "project_cost", "start_year", "end_year", "project_type", "contact_agency", "project_system"],
                        popupTemplate: popupCIP,
                        renderer: linesRenderer,
                    });
                    this.view.whenLayerView(this.cip_lines).then(f => f.filter = new FeatureFilter(this.filter))

                    this.map.add(this.cip_lines, 3);

                    this.getData('cip_lines');

                    let pointRenderer = {
                        type: "unique-value",
                        field: "project_system",
                        legendOptions: {
                            title: "Project System"
                        },
                        uniqueValueInfos: [
                            this.createMarkerSymbol("Road", "#3c3d3b"),
                            this.createMarkerSymbol("Water", "#3969AC"),
                            this.createMarkerSymbol("Sewer", "#11A579"),
                            this.createMarkerSymbol("Storm", "#F2B701"),
                            this.createMarkerSymbol("Electric", "#E73F74"),
                            this.createMarkerSymbol("Gas", "#80BA5A"),
                            this.createMarkerSymbol("Telecommunications", "#4b4b8f"),
                        ]
                    };


                    this.cip_points = new FeatureLayer({
                        url: "https://services5.arcgis.com/7W8dXhZugABWPKmQ/ArcGIS/rest/services/PointLayer_region/FeatureServer/0",
                        outFields: ["project_name", "project_cost", "start_year", "end_year", "project_type", "contact_agency", "project_system"],
                        popupTemplate: popupCIP,
                        renderer: pointRenderer,
                    });
                    this.view.whenLayerView(this.cip_points).then(f => f.filter = new FeatureFilter(this.filter))

                    this.map.add(this.cip_points, 4);

                    this.getData('cip_points');

                    vue_this.$emit('start_years', vue_this.start_years)
                    vue_this.$emit('end_years', vue_this.end_years)
                    vue_this.$emit('project_types', vue_this.project_types)

                  this.largeareas = new FeatureLayer({
                    url: "https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/largeareas/FeatureServer/0",
                  });
                  this.view.whenLayerView(this.largeareas).then(this.fac_query())

                    this.legend = new Legend({
                        view: this.view,
                        layerInfos: [
                            {
                                layer: this.cip_points,
                                title: "Capital Improvement Project Points"
                            },
                            {
                                layer: this.cip_lines,
                                title: "Capital Improvement Project Lines"
                            },
                            {
                                layer: this.cip_polygons,
                                title: "Capital Improvement Project Areas"
                            }
                        ]
                    });

                    let legExpand = new Expand({
                        view: this.view,
                        content: this.legend
                    });


                    // Add widget to the bottom right corner of the view
                    this.view.ui.add(legExpand, "bottom-right");
                    this.view.ui.add("addData", "bottom-left");

                });
        },
        beforeDestroy() {
            if (this.view) {
                // destroy the map view
                this.view.container = null;
            }
        },
        watch: {
            filter: function () {
                if (this.view && this.cip_points && this.cip_polygons && this.cip_lines) {
                    this.view.whenLayerView(this.cip_points).then(f => f.filter = this.filter)
                    this.view.whenLayerView(this.cip_polygons).then(f => f.filter = this.filter)
                    this.view.whenLayerView(this.cip_lines).then(f => f.filter = this.filter)
                }
            },
          fac_filter: function () {
            if (this.view && this.largeareas) {
              this.view.whenLayerView(this.largeareas).then(this.fac_query())
            }
          }
        },
};

</script>

<style scoped>
    div {
        padding: 0;
        margin: 0;
        width: 100%;
        height: 100%;
    }

    #map {
        grid-column: 1;
        grid-row: 2;
        position: relative;
    }

    #info, #addData{
        background: none;
    }

    @media (max-width: 576px), print {
        #map {
            height: 75vh;
            grid-row: 3;
        }
    }
</style>
